@let endDate = cancellationDates()?.endDate;

<tlc-churn-flow-step-template>
  <div class="left">
    <div>
      <rt-icon name="check" size="large-xx" colorToken="colorIconSuccessDefault" />
    </div>
    <span class="heading">{{ 'tlc.churn_flow.steps.farewell.heading' | translate }}</span>
    @if (displayRenewOnceNote()) {
      <span class="subheading">{{
        'tlc.churn_flow.steps.farewell.renew_once_notice' | translate
      }}</span>
    }
    <span
      class="subheading"
      [innerHTML]="'tlc.churn_flow.steps.farewell.subheading' | translate: { date: endDate }"
    ></span>
    <rt-button variant="primary" (click)="backToBilling()"
      >{{ 'tlc.churn_flow.steps.farewell.cta' | translate }}
    </rt-button>
  </div>

  <div class="right">
    <span class="right-panel-heading">{{
      'tlc.churn_flow.steps.farewell.sorry_to_see_you_go' | translate
    }}</span>
    <tlc-churn-flow-testimonial [testimonial]="testimonial" />
  </div>
</tlc-churn-flow-step-template>
